import React from "react";
import { useTranslation } from "react-i18next";
import { TextInput } from "@common/textInput";
import { CostInput } from "./costInput";
import { Props } from "./types";
import styles from "./styles.scss";

function Form({ formData, edit }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.form}>
      <div className={styles.row}>
        <div className={styles.group}>
          <h2 className={styles.label}>{t("createCostProfile.name")}</h2>
          <TextInput
            placeholder=""
            value={formData.name}
            input={(name) => edit({ ...formData, name })}
            autoFocus
          />
        </div>
        <div className={styles.group}>
          <h2 className={styles.label}>{t("createCostProfile.cost")}</h2>
          <CostInput
            cost={formData.cost}
            input={(cost) => edit({ ...formData, cost })}
          />
        </div>
      </div>
      <div className={styles.group}>
        <h2 className={styles.label}>{t("createCostProfile.description")}</h2>
        <TextInput
          placeholder=""
          className={styles.description}
          value={formData.description}
          input={(description) => edit({ ...formData, description })}
          isMultiline
        />
      </div>
    </div>
  );
}

export { Form };
